import { SubmitButton } from 'components/common/buttons/SubmitButton';
import ErrorMessage from 'components/common/ErrorMessage';
import React, { useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

function DonotCover({
    isOpen,
    onClose,
    onConfirm,
    appointmentId,
    item,
    loader,
}) {

    const methods = useForm();
    const { control, formState: { errors }, handleSubmit , setValue } = methods;

    useEffect(() => {

        methods.reset({ dnc_reason: '' })

    }, [isOpen])

    useEffect(() => {
        setValue('dnc_reason', item?.appointment_details?.dnc_reason || '')
    }, [item,isOpen])
    

    return (
        <>
            <Modal isOpen={isOpen} toggle={onClose} centered className="modal-medium">
                <form action="" onSubmit={handleSubmit((data) => onConfirm(data, "dnc"))}>
                    <ModalHeader className='header_modal align-items-center'>
                        <h5 className="modal-title_u">Do Not Cover Job</h5>
                    </ModalHeader>
                    <ModalBody className='modal_form_body'>
                        <div className='step_cards step_1'>
                            <h2>Job ID: {appointmentId}</h2>
                            <div className="row-primary">
                                <h2>Reason</h2>
                                <div className='w-100'>
                                    {/* Reason */}
                                    <div className="row-primary w-100">
                                        <Controller
                                            name="dnc_reason"
                                            control={control}
                                            rules={{
                                                required: "Please write reason"
                                            }}
                                            render={({ field }) =>
                                                <>
                                                    <textarea
                                                        className="type_inp input-in"
                                                        {...field}
                                                        placeholder='Write reason ...'
                                                        required
                                                    >
                                                    </textarea>

                                                    {errors?.dnc_reason?.message && (
                                                        <ErrorMessage
                                                            text={errors?.dnc_reason?.message}
                                                        />
                                                    )}
                                                </>
                                            }

                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ModalBody>
                    <ModalFooter>
                        <SubmitButton buttonType="submit"  loader={loader} className={'yellow'} btnText="Do Not Cover" />
                        <button className="table_delete" type='button' onClick={onClose}>Cancel</button>
                    </ModalFooter>
                </form>
            </Modal>
        </>
    );
}

export default DonotCover;